module.exports = __webpack_public_path__ + "img/3f7f9de.jpg";